import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { UpdateProactSettingRequest } from 'src/api/FiretrolApiClient';
import { proactSettingApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';
import { invalidateFor } from 'src/api/queries/invalidationMap';

const SETTINGS_STALE_TIME = 5 * 60_000;

export function useProactSettings() {
  return useQuery({
    queryKey: queryKeys.proact.settings(),
    queryFn: ({ signal }) => proactSettingApiClient.get(toCancelToken(signal)),
    staleTime: SETTINGS_STALE_TIME,
    meta: { suppressErrorToast: true, errorContext: 'Proact settings' },
  });
}

export function useUpdateProactSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: UpdateProactSettingRequest) =>
      proactSettingApiClient.update(request),
    meta: { successMessage: 'Proact settings saved!' },
    onSuccess: (saved) => qc.setQueryData(queryKeys.proact.settings(), saved),
    onSettled: () => invalidateFor('proact.update', qc),
  });
}
